import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';

import get from 'lodash.get';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    FertilizerWorksheetEntitySummary
} from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectFertilizerWorksheetEntitySummaries = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (worksheetState, index) =>
        get(worksheetState, [
            'pages',
            index,
            'entitySummaries'
        ]) as FertilizerWorksheetEntitySummary[]
);

const makeSelectFertilizerWorksheetEntitySummaries =
    (): typeof selectFertilizerWorksheetEntitySummaries =>
        selectFertilizerWorksheetEntitySummaries;

export {
    selectPageIndex,
    selectFertilizerWorksheetEntitySummaries,
    makeSelectFertilizerWorksheetEntitySummaries
};
